import React, { forwardRef } from 'react';
import { NumericTextBox } from '@progress/kendo-react-inputs';

/**
 * @typedef {React.ComponentProps<NumericTextBox>} TelerikNumericTextBoxProps
 *
 * @param {TelerikNumericTextBoxProps} props
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement}
 */
const BaseNumericInput = ({ onKeyDown, ...props }, ref) => {
  const handleKeyDown = (e) => {
    // Enter
    if (e.keyCode === 13) {
      e.preventDefault(); // Ensure it is only this code that runs
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  return (
    <span data-testid={props.id}>
      <NumericTextBox ref={ref} spinners={false} onKeyDown={handleKeyDown} {...props} />
    </span>
  );
};

/**
 * A base numeric input component with various options and handlers.
 *
 * @param {TelerikNumericTextBoxProps} props Component props. Extends Telerik NumericTextBox's props.
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement} Base numeric input component.
 */
const ForwardNumericInput = forwardRef(BaseNumericInput);

export default ForwardNumericInput;
